import { NextSeo } from 'next-seo';

//screens
import { ClaimsProcessing } from '@/screens/Agents/ClaimsProcessing';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function ClaimsProcessingPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/ai/claims-processing/"
        title="Claims Processing Agent | Loadsmart AI"
        description="Gathers the documentation, validates the claim against the shipment record, and drafts the filing for your approval — so claims get filed and recovered."
        openGraph={{
          url: 'https://loadsmart.com/ai/claims-processing/',
        }}
      />
      <JsonLd data={Organization} />
      <ClaimsProcessing />
    </>
  );
}
